import { useEffect, useState } from "react";
import { Table } from "reactstrap";
import empresaService from "services/EmpresaService";

export default function DetalhesEmpresa({ idEmpresa }) {
  const [responsaveisTecnicos, setResponsaveisTecnicos] = useState([])
  const [prepostos, setPrepostos] = useState([])

  useEffect(() => {
    if (idEmpresa) {
      empresaService.getResponsavelTecnico(idEmpresa).then(res => {
        if (res.success) {
          setResponsaveisTecnicos(res.data)
        } else {
          setResponsaveisTecnicos([])
        }
      })
      empresaService.getPreposto(idEmpresa).then(res => {
        if (res.success) {
          setPrepostos(res.data)
        } else {
          setPrepostos([])
        }
      })
    }
  }, [idEmpresa])

  return (
    <div className="row">
      <div className="col-6">
        <h4>Responsáveis técnicos</h4>
        <Table className="align-items-center table-flush" responsive>
          <thead className="thead-light">
            <tr>
              <th scope="col">Nome</th>
              <th scope="col">Telefone</th>
              <th scope="col">Email</th>
            </tr>
          </thead>
          <tbody>
            {responsaveisTecnicos.map(el => (
              <tr key={el.id}>
                <td>{el.nome}</td>
                <td>{el.telefone}</td>
                <td>{el.email}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
      <div className="col-6">
        <h4>Prepostos</h4>
        <Table className="align-items-center table-flush" responsive>
          <thead className="thead-light">
            <tr>
              <th scope="col">Nome</th>
              <th scope="col">Telefone</th>
              <th scope="col">Email</th>
            </tr>
          </thead>
          <tbody>
            {prepostos.map(el => (
              <tr key={el.id}>
                <td>{el.nome}</td>
                <td>{el.telefone}</td>
                <td>{el.email}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
    </div>
  )
}